import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import BButtonSubmitButton from 'JS/components/blain-form/BButtonSubmitButton.vue';
import BForm from 'JS/components/blain-form/BForm.vue';
import bugsnagClient from 'JS/global/bugsnag';
import CreatePasswordField from './CreatePasswordField.vue';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import ExternalAuthLogin from './ExternalAuthLogin.vue';
import HorizontalTextDivider from 'JS/components/HorizontalTextDivider.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { BCheckbox, BTextField } from "Src/js/components/blain-form";
import { BPhoneNumberField } from 'Src/js/components/blain-form';
import { CreateOauthAccountRequest, ICreateAccountResource, ICreateAccountResponse, LoginMethod, LoginPageType } from 'JS/types/Account';
import { nextTick, onMounted, ref } from 'vue';
import { IJoinRewardsStep, IVerifyUserData } from 'JS/types/rewards';
import { RewardsReasonCode } from 'JS/types/rewards';
import { useServices } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAccountPage',
  props: {
    skipCartMerge: { type: Boolean },
    antiForgeryToken: null
  },
  emits: ["change-page", "loading", "go-to-rewards", "go-to-rewards-with-oauth", "signed-in", "go-to-select-account", "go-to-enter-phone"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'change-page', page: LoginPageType): void;
	(event: 'loading', value: boolean): void;
	(event: 'go-to-rewards', page: IJoinRewardsStep, data?: IVerifyUserData, createAccountRequest?: ICreateAccountResource, returnPage?: LoginPageType): void;
	(event: 'go-to-rewards-with-oauth', page: IJoinRewardsStep, data?: IVerifyUserData, createOauthAccountRequest?: CreateOauthAccountRequest, returnPage?: LoginPageType): void;
	(event: 'signed-in'): void;
	(event: 'go-to-select-account', response: ICreateAccountResponse, request: ICreateAccountResource): void;
	(event: 'go-to-enter-phone', createOauthAccountRequest: CreateOauthAccountRequest, returnPage: LoginPageType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	skipCartMerge: boolean,
	antiForgeryToken: string,
}





const { accountService } = useServices();

const createAccountRequest = ref<ICreateAccountResource>({
	firstName: '',
	lastName: '',
	emailAddress: '',
	password: '',
	phoneNumber: '',
	saveLogin: true,
	skipConnectingRewards: false,
	hasDesyncedRewards: false,
});

const errorMessage = ref<string>("");
const headerFocuser = ref<HTMLElement | null>(null);

async function handleCreateAccount() {
	try {
		emit('loading', true);
		const result: ICreateAccountResponse = await accountService.createAccount(createAccountRequest.value, props.antiForgeryToken);
		if (!result?.success) {
			setCreateAccountErrorMessage(result);
			emit('loading', false);
		} else {
			window.blainGtmDataLayer.push({
				'event': "create_login",
				'loginMethod': LoginMethod.Local
			});
			window.blainGtmDataLayer.push({
				'event': "create_rewards"
			});
			if (result.headerJson && window.vueEventBus) {
				window.vueEventBus.$emit('header-vm', result.headerJson);
			}
			emit('go-to-rewards', 'success');
		}
	} catch (err) {
		errorMessage.value = "Something went wrong. Please try again later.";
		emit('loading', false);
		bugsnagClient.notify(err);
	}
}

function setCreateAccountErrorMessage(result: ICreateAccountResponse) {
	switch (result?.reasonCode) {
		case RewardsReasonCode.REWARDS_ACCOUNT_ALREADY_LINKED:
			errorMessage.value = `<span class='bold'>This phone number is already associated with another user, ${result.email}.</span><span style='font-weight: normal'> Please enter a different number or call Customer Service at <a style='text-wrap: nowrap' class='black' href='tel:+1-800-210-2370'>1-800-210-2370</a> for help.</span>`;
			break;
		case RewardsReasonCode.REWARDS_ACCOUNT_ALREADY_EXISTS:
			emit('go-to-rewards',
				'verification-join',
				{ phone: result.phone, email: result.email, variant: 'verification-join', redactedData: result.redactedData },
				createAccountRequest.value,
				'create',
			);
			break;
		case RewardsReasonCode.PHONE_AND_EMAIL_SEPARATE_MATCH:
			emit('go-to-select-account', result, createAccountRequest.value );
			break;
		case RewardsReasonCode.SESSION_M_ERROR:
			bugsnagClient.notify("SessionM error occured while attempting to Join Rewards.");
		default:
			errorMessage.value = result.errorMessage;

	}
}

onMounted(() => {
	nextTick(()=> headerFocuser.value?.focus());
});


return { __sfc: true,props, emit, accountService, createAccountRequest, errorMessage, headerFocuser, handleCreateAccount, setCreateAccountErrorMessage, validation, BButtonSubmitButton, BForm, CreatePasswordField, ErrorBanner, ExternalAuthLogin, HorizontalTextDivider, LinkButton, BCheckbox, BTextField, BPhoneNumberField }
}

})